

















































































































































import { Vue, Component } from "vue-property-decorator";

import { filter, first } from "rxjs/operators";

import SignUpForm from "./SignUpForm.vue";
import { Subscription } from "rxjs";
import { RMUser } from "./api";
import { EMAIL_PATTERN } from "../util";

/* eslint no-control-regex: "off" */
@Component({
  components: { SignUpForm }
})
export default class LoginPage extends Vue {
  subscriptions: Subscription[] = [];

  error = "";
  intent = "login";
  showResetPasswordDialog = false;
  requestEmail = "";
  state: "idle" | "busy" | "done" = "idle";
  valid = false;
  input = {
    valid: false,
    email: "",
    password: "",
    emailRules: [
      (v: any) => !!v || "E-mail is required",
      (v: any) => (v && EMAIL_PATTERN.test(v)) || "Please enter a valid email."
    ],
    passwordRules: [(v: any) => !!v || "Please enter a password"]
  };

  showAlert = false;
  alertMessage = "";
  alertType = "success";
  showOnboarding = true;

  cycle = false;
  onboards = [
    // { title: "How it works?", description: "", logo: "mortgage" },
    {
      title: "We find quality properties.",
      description: "We screen and vet properties for balanced growth and risk",
      logo: "financial"
    },
    {
      title: "You invest.",
      description: "Buy fractional shares for partial ownership",
      logo: "buy"
    },
    {
      title: "You get paid monthly cash dividends.",
      description: "Rental income is distributed to shareholders",
      logo: "rent"
    },
    {
      title: "You earn when the property sells.",
      description:
        "As property value increases, receive your share of the sale proceeds",
      logo: "loan"
    }
  ];
  carousalIdx = 0;

  mounted() {
    this.authService.user
      .pipe(
        filter((u): u is RMUser => u != null && u.isAnonymous === false),
        first()
      )
      .subscribe(u =>
        u.waitListed ? this.showWaitList(u.email!) : this.$router.push("/main")
      );
  }

  beforeDestory() {
    // this.subscriptions.forEach(s => s.unsubscribe())
  }

  async login() {
    if (!this.input.valid) return;
    this.error = "";
    this.state = "busy";

    try {
      const user = { email: this.input.email, password: this.input.password };
      await this.authService.loginWithEmailPassword(user);
    } catch (error) {
      this.state = "idle";
      this.error = error.message;
    }
  }

  showPasswordDialog() {
    this.showResetPasswordDialog = true;
  }

  async requestNewPassword() {
    this.showAlert = false;
    // @ts-ignore
    if (this.$refs.form.validate()) {
      try {
        await this.authService.resetPassword(this.requestEmail);
        this.showResetPasswordDialog = false;
        // @ts-ignore
        this.$refs.form.reset();
        this.showAlert = true;
        this.alertMessage = "Request sent. Please check your email.";
        this.alertType = "success";
      } catch (error) {
        this.showResetPasswordDialog = false;
        this.showAlert = true;
        this.alertMessage = error.message;
        this.alertType = "error";
      }
    }
  }

  async loginWithGoogle() {
    this.error = "";
    this.state = "busy";
    try {
      const credentials = await this.authService.loginWithGoogle();
      if (
        credentials.additionalUserInfo &&
        credentials.additionalUserInfo.isNewUser
      ) {
        this.showWaitList(credentials.user!.email!);
      }
    } catch (error) {
      this.error = error.message;
    } finally {
      this.state = "idle";
    }
  }

  showWaitList(email: string) {
    this.authService.logout();
    window.location.href =
      "https://referlist.co/joinwaitList/remoteventures86f56?email=" + email;
    // staging TODO put in .env
    // window.open('https://referlist.co/joinwaitList/remoteventuresapp?email=' + email)
    // this.$router.replace('/waitList')
  }

  skipOnboarding() {
    this.showOnboarding = false;
  }

  swipe(direction: string) {
    switch (direction) {
      case "Left":
        this.carousalIdx++;
        break;
      case "Right":
        this.carousalIdx--;
        break;
    }
    if (this.carousalIdx > this.onboards.length - 1 && direction === "Left") {
      this.skipOnboarding();
    }
  }
}
